import { Card, DatePicker, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { disableFutureDates, formatDate } from "../../services/util";
import moment from "moment";
import { FullscreenOutlined, LoadingOutlined } from "@ant-design/icons";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { pieChartConfigurationOption } from "../../config";
import Chart from "react-google-charts";
import { SupportTicketTable } from "./SupportTicketTable";

function HighestTicketPropertyChart() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [chartData, setChartData] = useState([
        [`months`, "Success Percentage"],
    ]);
    const [enableZoom, setEnableZoom] = useState(false);
    const [componentList, setComponentList] = useState([]);
    const [chartBy, setChartBy] = useState("year");
    const [formData, setFormData] = useState({
        start_date: formatDate(moment().subtract(7, "day")),
        end_date: formatDate(moment()),
        staff_id,
        component_name: componentList[0] || "",
        chart_by: "year",
    });
    const [selectedHotelForTableView, setSelectedHotelForTableView] =
        useState(0);
    const {
        status: componentStatus,
        data: componentsData,
        refetch: getComponents,
    } = useQuery(
        "hubspot-components",
        async () => {
            return await HTTP("/dashboard/getJiraComponents", { staff_id });
        },
        { enabled: false },
    );

    const {
        status: chartStatus,
        data: HightestTicketsPropertyChartData,
        refetch,
    } = useQuery(
        "HightestTicketsPropertyChart",
        async () => {
            return await HTTP(`/dashboard/getPropertiesWithMostIssues`, {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        getComponents();
    }, []);

    useEffect(() => {
        refetch();
    }, [formData]);

    useEffect(() => {
        if (componentStatus == "success") {
            setComponentList(componentsData.data);
        }
    }, [componentStatus, componentsData]);

    useEffect(() => {
        if (chartStatus == "success") {
            setChartData(HightestTicketsPropertyChartData?.data);
        }
    }, [chartStatus, HightestTicketsPropertyChartData]);

    const handleSelectChange = (e) => {
        setFormData({ ...formData, component_name: e });
    };

    return (
        <Card className="box-shadow" style={{ width: "53%" }}>
            <div className="flex space-between">
                <strong>Top 5 property having max no of issues</strong>
                <div className="flex flex-gap-10 align-center">
                    <Select
                        value={chartBy}
                        defaultValue={chartBy}
                        placeholder="Chart By"
                        style={{ width: "30%" }}
                        onChange={(val) => {
                            setChartBy(val);
                            setFormData({ ...formData, chartBy: val });
                        }}
                    >
                        <Select.Option key={`Year`} value={`year`}>
                            Year
                        </Select.Option>
                        <Select.Option key={`Date`} value={`day`}>
                            Date
                        </Select.Option>
                    </Select>
                    {chartBy == `year` ? (
                        <DatePicker
                            allowClear={false}
                            picker="year"
                            defaultValue={moment()}
                            disabledDate={disableFutureDates}
                            placeholder="Year"
                            style={{ width: "100px" }}
                            onChange={(_, y) => {
                                setFormData({
                                    ...formData,
                                    start_date: formatDate(
                                        new Date(`${y}`, 0, 1),
                                    ),
                                    end_date: formatDate(
                                        new Date(`${y}`, 11, 31),
                                    ),
                                });
                            }}
                        />
                    ) : (
                        <DatePicker.RangePicker
                            defaultValue={[
                                moment(formData.start_date),
                                moment(formData.end_date),
                            ]}
                            onChange={(e) => {
                                setFormData({
                                    ...formData,
                                    start_date: formatDate(e[0]),
                                    end_date: formatDate(e[1]),
                                });
                            }}
                            allowClear={false}
                            disabledDate={disableFutureDates}
                            format="MM/DD/YYYY"
                            ranges={{
                                "Last 7 Days": [
                                    moment().subtract(7, "day"),
                                    moment(),
                                ],
                                "Last 30 Days": [
                                    moment().subtract(29, "day"),
                                    moment(),
                                ],
                                "Current Month": [
                                    moment().startOf("month"),
                                    moment(),
                                ],
                                "Last Month": [
                                    moment()
                                        .subtract(1, "month")
                                        .startOf("month"),
                                    moment()
                                        .subtract(1, "month")
                                        .endOf("month"),
                                ],
                                "Last 3 Month": [
                                    moment().subtract(3, "month"),
                                    moment(),
                                ],
                            }}
                        />
                    )}
                    <Select
                        defaultValue={
                            formData.component_name
                                ? formData.component_name
                                : null
                        }
                        value={
                            formData.component_name
                                ? formData.component_name
                                : null
                        }
                        allowClear
                        showSearch
                        placeholder="Components"
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        onChange={handleSelectChange}
                        loading={componentList.length === 0 ? true : false}
                        style={{ width: "250px" }}
                    >
                        {componentList.map((option) => (
                            <Select.Option
                                key={option.component_id}
                                value={option.component_name}
                            >
                                {`${option.component_name}`}
                            </Select.Option>
                        ))}
                    </Select>
                    <FullscreenOutlined
                        style={{ fontSize: "20px" }}
                        onClick={() => {
                            setEnableZoom(true);
                        }}
                    />
                </div>
            </div>
            {chartStatus == "success" ? (
                <Chart
                    options={{
                        ...pieChartConfigurationOption,
                        slices: {},
                    }}
                    data={chartData}
                    chartType="PieChart"
                    chartEvents={[
                        {
                            eventName: "select",
                            callback({ chartWrapper }) {
                                if (
                                    chartWrapper.getChart().getSelection()
                                        .length > 0
                                ) {
                                    setSelectedHotelForTableView(
                                        chartData[
                                            chartWrapper
                                                .getChart()
                                                .getSelection()[0].row + 1
                                        ][2],
                                    );
                                } else {
                                    setSelectedHotelForTableView(0);
                                }
                            },
                        },
                    ]}
                />
            ) : (
                <Spin
                    indicator={
                        <LoadingOutlined style={{ fontSize: 70 }} spin />
                    }
                />
            )}
            <Modal
                open={enableZoom}
                destroyOnClose
                onCancel={() => {
                    setEnableZoom(false);
                }}
                width={"fit-content"}
                height={"fit-content"}
                footer={""}
            >
                <Chart
                    options={{
                        title: "Top 5 property having max no of issues",
                        ...pieChartConfigurationOption,
                        slices: {},

                        width: "60vw",
                        height: "70vh",
                    }}
                    data={chartData}
                    chartType="PieChart"
                />
            </Modal>
            <Modal
                open={Boolean(selectedHotelForTableView)}
                destroyOnClose
                width={"fit-content"}
                height={"fit-content"}
                footer={""}
                onCancel={() => {
                    setSelectedHotelForTableView(0);
                }}
            >
                <SupportTicketTable
                    hotel_ids={[selectedHotelForTableView]}
                    start_date={formData.start_date}
                    end_date={formData.end_date}
                />
            </Modal>
        </Card>
    );
}

export default HighestTicketPropertyChart;
